export default __webpack_public_path__ + "static/media/slide_2_mobile.2ff7a3f7.png";